import React from 'react';

const Loader = () => <div className="Loader" />;

export default Loader;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/components/Loader.jsx